module.exports = __webpack_public_path__ + "img/107-kwait.41603662.svg";